//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

let checkPassword = (rule, value, callback) => {
  let reg = /^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$).{6,20}$/;
  if (!reg.test(value)) {
    callback(new Error("请输入6-20个字母、数字和符号两种及以上的组合字符"));
  } else {
    callback();
  }
};
export default {
  // layout: "menu",
  head() {
    return {
      title: "忘记密码-密码找回-飙局",
      meta: [
        {
          name: "description",
          content: ""
        },
        {
          name: "keywords",
          content: ""
        }
      ]
    };
  },
  data() {
    return {
      repeatCountDown: 0,
      interval: null,
      loginInterval: null,
      active: 0,
      picCodeUrl: null,
      isPhone: false,
      showPhone: "",
      showOk: false,
      countDown: 3,
      checkCode:null,
      form1: {
        account: "",
        imgcode: ""
      },
      form2: {
        code: ""
      },
      form3: {
        pwd: "",
        confirmPwd: ""
      },
      rules1: {
        account: [
          {
            required: true,
            message: "请输入手机号/邮箱",
            trigger: "blur"
          },
          {
            trigger: "blur",
            validator: (rule, value, callback) => {
              var reg = /^1\d{10}$/; //手机号
              var reg2 = /[\d\w\._-]+@[\d\w]+\.[\w]+/; //邮箱
              if (!reg.test(value) && !reg2.test(value)) {
                callback(new Error("请输入正确的手机号或邮箱!"));
              } else {
                callback();
              }
            }
          }
        ],
        imgcode: [
          { required: true, message: "请输入图形验证码", trigger: "blur" }
        ]
      },
      rules2a: {
        code: [{ required: true, message: "请输入手机校验码", trigger: "blur" }]
      },
      rules2b: {
        code: [{ required: true, message: "请输入邮箱验证码", trigger: "blur" }]
      },
      rules3: {
        pwd: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          { validator: checkPassword, trigger: "blur" }
        ],
        confirmPwd: [
          { required: true, message: "请重新输入你的新密码", trigger: "blur" },
          { validator: checkPassword, trigger: "blur" },
          {
            trigger: "blur",
            validator: (rule, value, callback) => {
              if (value === this.form3.pwd) {
                callback();
              } else {
                callback(new Error("密码输入不一致"));
              }
            }
          }
        ]
      }
    };
  },
  async asyncData({ error, query, $axios, params }) {
    try {
      const [res] = await Promise.all([$axios.get("/api/Auth/initForgetPwd")]);
      return {
        initData: res.data.data,
        queryPam: query
      };
    } catch (err) {
      error(err);
    }
  },
  head() {
    return {
      title: this.initData ? this.initData.seo.title : "",
      meta: [
        {
          name: "description",
          content: this.initData ? this.initData.seo.description : ""
        },
        {
          name: "keywords",
          content: this.initData ? this.initData.seo.keywords : ""
        }
      ]
    };
  },
  created() {
    let code = this.$route.query.code;
    let account = this.$route.query.account;
    if (code && account) {
      this.form2.code = code;
      this.form1.account = account;
      this.isPhone = false;
      this.active = 1;
      this.repeatCd();
    }
  },
  mounted() {
    this.getPicCode();
  },
  methods: {
    getPicCode() {
      this.$axios.get("/api/Auth/graphVerifyCode").then(res => {
        this.picCodeUrl = res.data;
      });
    },
    next() {
      if (this.active == 0) {
        this.$refs.rules1.validate(valid => {
          if (valid) {
            const loading = this.$loading();
            this.$axios.post("/api/Auth/checkAccount", this.form1).then(res => {
              loading.close();
              if (res.data.code == 0) {
                let num = this.form1.account;
                if (num.indexOf("@") != -1) {
                  this.isPhone = false;
                } else {
                  this.isPhone = true;
                  this.showPhone = num.substr(0, 3) + "****" + num.substr(7);
                }
                this.active++;
                this.repeatCd();
              } else {
                this.getPicCode();
                this.$message.error(res.data.msg);
              }
            });
          } else {
            return false;
          }
        });
      } else if (this.active == 1) {
        let isok=true;
        if (this.isPhone) {
          this.$refs.rules2a.validate(valid => {
            console.log(valid)
            if (!valid) {
              isok=false;
            }
          });
        } else {
          this.$refs.rules2b.validate(valid => {
            if (!valid) {
              isok=false;
            }
          });
        }
        if(isok){
          const loading = this.$loading();
          this.$axios
            .post("/api/Auth/checkVerifyCode", {
              account: this.form1.account,
              verifycode: this.form2.code
            })
            .then(res => {
              loading.close();
              if (res.data.code == 0) {
                this.active++;
                this.checkCode=res.data.data.checkCode;
              } else {
                this.$message.error(res.data.msg);
              }
          });
        }

      } else if (this.active == 2) {
        this.$refs.rules3.validate(valid => {
          if (valid) {
            const loading = this.$loading();
            this.$axios
              .post("/api/Auth/resetPwd", {
                account: this.form1.account,
                pwd: this.form3.pwd,
                surepwd: this.form3.confirmPwd,
                checkCode:this.checkCode
              })
              .then(res => {
                loading.close();
                if (res.data.code == 0) {
                  this.showOk = true;
                  this.loginInterval = setInterval(() => {
                    if (this.countDown > 0) {
                      this.countDown--;
                    } else {
                      clearInterval(this.loginInterval);
                      this.$router.push("/login");
                    }
                  }, 1000);
                } else {
                  this.$message.error(res.data.msg);
                }
              });
          } else {
            return false;
          }
        });
      }
    },
    repeat() {
      if (this.repeatCountDown > 0) {
        return;
      }

      this.$axios
        .post("/api/Auth/reSendCode", { account: this.form1.account })
        .then(res => {
          if (res.data.code == 0) {
            this.$message.success(res.data.msg);
            this.repeatCd();
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    repeatCd() {
      this.repeatCountDown = 60;
      this.interval = setInterval(() => {
        if (this.repeatCountDown > 0) {
          this.repeatCountDown--;
        } else {
          clearInterval(this.interval);
        }
      }, 1000);
    },
    beforeDestroy() {
      clearInterval(this.interval);
      this.interval = null;
      clearInterval(this.loginInterval);
      this.loginInterval = null;
    }
  }
};
